// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"69":"74225518852209d776a1","655":"b0b87d0a671c45ca5bf2"}[chunkId] + ".js";
};